<template>
  <section>
    <b-button variant="danger" @click="$bvModal.show('modal-group-del')" v-if="show">
      <b-icon icon="trash-fill" aria-hidden="true"></b-icon> Deletar Ilha
    </b-button>

    <b-modal
      id="modal-group-del"
      title="Deletar Ilha"
      centered
      size="sm"
      @hide="resetForm"
    >
      <b-row class="justify-content-md-center">
        <b-col>
          <label for="select-queues">Ilhas:</label>
          <b-input-group>
            <template #prepend>
              <b-input-group-text><i class="fas fa-users"></i></b-input-group-text>
            </template>
            <b-form-select
              v-model="selectedQueue"
              :options="queueOptions"
              id="select-queues"
              :state="queueState"
              :class="{'is-invalid': !queueState && touchedQueue}"
              @blur="touchedQueue = true"
            >
            </b-form-select>
            <b-form-invalid-feedback v-if="!queueState && touchedQueue">
              Selecione uma ilha!
            </b-form-invalid-feedback>
          </b-input-group>
        </b-col>
      </b-row>

      <template #modal-footer>
        <div class="float-right">
          <b-button
            variant="secondary"
            size="sm"
            @click="handleCancel"
          >
            Cancelar
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            @click="deleteGroup"
          >
            Deletar
          </b-button>
        </div>
      </template>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: "FormDelGroup",
  data() {
    return {
      nome: null,
      show: true,
      queueOptions: [],
      selectedQueue: null,
      touchedQueue: false
    };
  },
  methods: {
    deleteGroup() {
      this.touchedQueue = true;

      if (this.selectedQueue) {
        fetch('/deleteGroup', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: this.selectedQueue  // Enviar o ID do grupo selecionado
          })
        })
        .then(response => response.json())
        .then(data => {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Grupo excluído com sucesso",
            showConfirmButton: false,
            timer: 1500,
          });
          this.$bvModal.hide('modal-group-del');
          this.resetForm();
          this.fetchQueues();
        })
        .catch(error => {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Falha ao excluir o grupo",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      }
    },
    fetchQueues() {
      fetch('/listGroups')
        .then(response => response.json())
        .then(data => {
          this.queueOptions = Object.keys(data).map(key => {
            return {
              text: key,  // O nome do grupo será mostrado
              value: data[key].id  // O ID do grupo será o valor
            };
          });
          console.log(this.queueOptions);  // Verificar a estrutura do array
        })
        .catch(error => {
          console.error('Error fetching queues:', error);
        });
    },
    handleCancel() {
      this.resetForm();
      this.$bvModal.hide('modal-group-del');
    },
    resetForm() {
      this.selectedQueue = null;
      this.touchedQueue = false;
    }
  },
  computed: {
    queueState() {
      return this.selectedQueue !== null;
    }
  },
  mounted() {
    this.fetchQueues();
  }
};
</script>

<style scoped>
</style>
